<template>
  <div class="tests">
    <h1>TestDetails</h1>
    <TestCard v-for="test in tests" :key="test.Code" :test="test" />
  </div>
</template>

<script>
import TestCard from '@/components/TestCard.vue'
import TestService from '@/services/TestService.js'


export default {
  name: "About",
  props: {
    searchValue: String
  },
  components: {
    TestCard
  },
  data() {
    return {
      tests: null
    }
  },
  created() {
    TestService.getTests()
    .then(response => {
      //console.log('tests:', response.data)
      this.tests = response.data
    })
    .catch(error => {console.log(error)})
  }
}
</script>

<style scoped>
.tests {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
